import {
  Box,
} from '@mui/material';

const Loading = () => (
  <Box
    position="fixed" // DEIXAR FIXED
    left={0}
    top={0}
    display="flex"
    justifyContent="center"
    alignItems="center"
    width="100vw"
    height="100vh"
    sx={{
      zIndex: 1100,
      backgroundColor: 'white',
    }}
  >
    LOADING...
  </Box>
);

export default Loading;
